import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { auth, database } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { ref, set } from 'firebase/database';

const GithubAuthCallback = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [status, setStatus] = useState('Connecting GitHub…');

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setStatus('Sign in first, then retry.');
        return;
      }
      const code = params.get('code');
      const state = params.get('state');
      const expectedState = sessionStorage.getItem('gh_oauth_state');
      const projectId = sessionStorage.getItem('gh_oauth_project_id') || null;

      if (!code) {
        setStatus('Missing OAuth code. Aborting.');
        return;
      }
      if (state && expectedState && state !== expectedState) {
        setStatus('State mismatch. Aborting.');
        return;
      }

      try {
        const r = await fetch('/api/github/exchange-code', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            code,
            redirect_uri: `${window.location.origin}/oauth/github/callback`,
          }),
        });
        const data = await r.json();
        if (!r.ok || !data.access_token) {
          setStatus(`OAuth failed: ${data.error || r.statusText}`);
          return;
        }
        await set(ref(database, `users/${user.uid}/integrations/github`), {
          accessToken: data.access_token,
          scope: data.scope || '',
          connectedAt: Date.now(),
        });
        sessionStorage.removeItem('gh_oauth_state');
        sessionStorage.removeItem('gh_oauth_project_id');
        setStatus('Connected. Redirecting…');
        navigate(projectId ? `/board?project=${projectId}` : '/board', { replace: true });
      } catch (e) {
        setStatus(`Network error: ${e.message}`);
      }
    });
    return () => unsub();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#0a2a5e', color: '#e6f0ff', fontFamily: 'Inter, system-ui, sans-serif' }}>
      <div style={{ padding: 24, textAlign: 'center' }}>
        <div style={{ fontSize: 18, marginBottom: 12 }}>GitHub</div>
        <div style={{ opacity: 0.85 }}>{status}</div>
      </div>
    </div>
  );
};

export default GithubAuthCallback;
